import React from "react";
import styled from "styled-components";
import { Cross } from "../../../assets/images/Cross";

const InputField = ({
  label,
  placeholder,
  value,
  onChange,
  disabled,
  errormessage,
  required,
  type = "text",
}) => {
  const handleClear = () => {
    if (onChange) onChange("");
  };

  return (
    <InputContainer>
      {label && <Label>{label}</Label>}
      <InputWrapper errormessage={errormessage} disabled={disabled}>
        <StyledInput
          required={required}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          disabled={disabled}
        />
        <ClearButtonContainer
          type="button"
          onClick={handleClear}
          disabled={disabled || !value}
        >
          <Cross />
        </ClearButtonContainer>
      </InputWrapper>
      {errormessage && <ErrorMessage>{errormessage}</ErrorMessage>}
    </InputContainer>
  );
};

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin: 1.5rem 0;
  width: 100%;
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.3125rem;
  color: #0c0c0e;
`;

const InputWrapper = styled.div`
  min-height: 1.313rem;
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => (props.errormessage ? "#D52566" : "#E4DEF9")};
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  background: ${(props) => (props.disabled ? "#F5F5F5" : "white")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: all 0.4s;

  &:active,
  &:hover {
    border: 1px solid #ccc2ef;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-size: 0.875rem;
  min-height: 1.375rem;
  padding: 0;

  &:disabled {
    background: none;
    color: #bdbdbd;
  }
`;

const ClearButtonContainer = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #9e9e9e;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #616161;
  }

  &:disabled {
    display: none;
  }
`;

const ErrorMessage = styled.span`
  font-size: 0.75rem;
  color: #d52566;
`;

export default InputField;
